import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";

export default class WayResult extends SymbolWinResult {

    public name: string = "way";
    public line: number;

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/builders/way-result.ts